/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


jQuery(document).ready(function($) {
	
			$('#dl-menu').dlmenu();






			 $('img.svg').each(function(){
			 
            var $img = $(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });
        
     if($(window).width() < '990') { 
		    var mySwipersm = new Swiper ('.swiper-container', {
		      // Optional parameters
		      direction: 'horizontal',
		      loop: true,
		      slidesPerView: 3,
		    });      
		}
     if($(window).width() < '780') { 
		    var mySwiperxs = new Swiper ('.swiper-container', {
		      // Optional parameters
		      direction: 'horizontal',
		      loop: true,
		      slidesPerView: 2,
		    });      
		}
		
		var countslide = 3;
	if($(window).width() > '1440') {
		 countslide = 3;
	}		
	if($(window).width() < '1440') {
		 countslide = 3;
	}		
	if($(window).width() < '990') {
		 countslide = 3;
	}		
	if($(window).width() < '590') {
		 countslide = 1;
	}		
	var productswiper = new Swiper('.product-images', {
        centeredSlides: false,
        scrollbarHide: false,
        paginationClickable: true,
        spaceBetween: 0,
        loop: true,
        slidesPerView: countslide,
        grabCursor: true,
        autoplay: 2000,
        autoplayDisableOnInteraction: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        controlInverse: true,
        pagination:'.swiper-pagination',
        preloadImages: true,
        lazyLoading: true,
    });	
    
    if($('.productslist.mobile').length > 0) {
		var slpv = 2;
		if($(window).width() < '590') {
			 slpv = 1;
		}		
	    var products = new Swiper('.productslist.mobile', {
	            slidesPerView: slpv,
	            loop: true,
		        nextButton: '.swiper-button-next2',
		        prevButton: '.swiper-button-prev2',
		        controlInverse: true,
		        pagination:'.swiper-pagination2',
	    });
	
	    if($('.activeproduct').length > 0) {
	    	products.slideTo($('.activeproduct').data('swiper-slide-index')+1);
		}	

		
    }
    
    lightbox.option({
	    showImageNumberLabel: false
    });
    
    $('.productslist li.mainitem > a').click(function() {
	    if($(this).parents('li').find('.childproducts').length > 0) {
		   $('.childproducts').hide(); 
		   $(this).parent('li').find('ul').addClass('active').show(); 
		   return false;
	    } 
    });
    
    
    $('.question').click(function() {
	    $('.faqcontainer .ans').hide();
	    $(this).parent('li').find('.ans').toggle();
	    
    });
    
    $('.readmore').click(function() {
	    var currentContent = $(this).closest('.team').find('.team-content');
	    
	    if($(this).hasClass('active')) {
		    $(this).removeClass('active'); 
		    $(this).text('Lees meer');
		    $(currentContent).animate({height: '300px'}, 1000 );
		} else {
			$(this).addClass('active');
		    $(this).text('Lees minder');
		    $(currentContent).animate({height: $(currentContent).get(0).scrollHeight}, 1000 );
		}
    });

	$('#newsletterform').submit(function() {
			var data= $(this).serialize();
			jQuery.post( "/hellodialog.php", data, function( data ) {
				
				if(data === 'false') {
					$('.returnmessage').append('<span class="glyphicon glyphicons-remove-sign">Er is een fout opgetreden, probeer het nogmaals.<span>');
					jQuery('.returnmessage').fadeIn();
				} else {
					$('form').hide();
					jQuery('.returnmessage').html('<span class="glyphicon glyphicon-ok-circle"></span> <p>Uw aanvraag is succesvol verzonden.</p>');
					jQuery('.returnmessage').fadeIn();
					__gaTracker('send', 'event', 'nieuwsbrief', 'ingeschreven');
					fbq('trackCustom', 'nieuwsbrief inschrijving', {location: window.location.href });
					//jQuery.get('/wp-content/themes/vraaghethier/logout.php', function() {});
				}
				
			});		
				
	});


if($(window).width() > 800) {
$("#videopopup").hover(function() {
  $(this).prop("controls", true);
}, function() {
  $(this).prop("controls", false);

});

} else {
$("#video").hover(function() {
  $(this).prop("controls", true);
}, function() {
  $(this).prop("controls", false);

});
}



	$('video#video').click(function() {
		if($(window).width() > 800) {
			$('.videobox-popup').show();
			$(this).get(0).pause();
		} else {
			if($('video#video').get(0).paused) {
				$(this).get(0).play();
				__gaTracker('send', 'event', 'video', 'afgespeeld',$(this).data('content'));
			} else {
				$(this).get(0).pause();
			}
		}
	});
	
	$('.videobox-popup .close').click(function() {
		$('.videobox-popup').hide();
		$('.videobox-popup video').get(0).pause();
	});

	$('.videobox-popup').click(function(evt){   
		
       if(evt.target.id == "videopopup")
          return;
	
		$('.videobox-popup').hide();
		$('.videobox-popup video').get(0).pause();
	});



});